import {
  jb_cookie_settings_css_default
} from "./chunk.ZDYI2F7C.js";
import {
  JbRichtext
} from "./chunk.VP6VMQEH.js";
import {
  JbButtonSwitch
} from "./chunk.IFPVFIUA.js";
import {
  reset_css_default
} from "./chunk.PBU2AIHD.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Initiable
} from "./chunk.6DHNIVN5.js";
import {
  JBCookie
} from "./chunk.NKAUZW5M.js";
import {
  D,
  ke,
  r
} from "./chunk.NBIYIO67.js";
import {
  n
} from "./chunk.QXWAL3TN.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-cookie-settings/jb-cookie-settings.ts
var JbCookieSettings = class extends Initiable(r) {
  constructor() {
    super(...arguments);
    this.ARIALABELS_DEFAULT = {
      closeCookieSettings: "Close cookie settings"
    };
    this._newCookieSettings = /* @__PURE__ */ new Map();
  }
  static create(data) {
    const childNodes = [];
    childNodes.push(
      new JbRichtext().init({
        innerHTML: data.introduction.content,
        props: { ...data.introduction, size: "small" },
        attributes: { slot: "introduction" }
      })
    );
    childNodes.push(
      ...data.options.map(
        (option) => new JbButtonSwitch().init({
          props: option,
          attributes: { slot: "options" }
        })
      )
    );
    if (data.additionalText) {
      childNodes.push(
        new JbRichtext().init({
          innerHTML: data.additionalText.content,
          props: { ...data.additionalText, size: "mini" },
          attributes: { slot: "additionalText" }
        })
      );
    }
    return new JbCookieSettings().init({ props: data, childNodes });
  }
  acceptAll() {
    this.addEventListener("button-switch:initialized", (event) => {
      this._forceSetting(event, true);
      this._save();
    });
    document.body.append(this);
    this.parentElement?.removeChild(this);
  }
  async firstUpdated(_changedProperties) {
    super.firstUpdated(_changedProperties);
    await this.updateComplete;
    setTimeout(() => {
      this.dispatchEvent(new CustomEvent("jb-focus-fly:reset", { bubbles: true }));
    }, 50);
  }
  setConsentFor(optionNames) {
    this.addEventListener("button-switch:initialized", (event) => {
      const buttonSwitch = event.detail.buttonSwitch;
      if (!buttonSwitch.name) {
        return;
      }
      if (optionNames.includes(buttonSwitch.name)) {
        this._forceSetting(event, true);
      }
    });
    document.querySelector("body")?.append(this);
    this.parentElement?.removeChild(this);
    window.setTimeout(() => {
      this._save();
    }, 0);
  }
  _buttonClicked(e) {
    e.stopPropagation();
    e.detail.clickEvent.preventDefault();
    if (e.detail.name === "save") {
      this._save();
      JBCookie.setCookie("hide_cookie_banner", "1");
      JBCookie.setCookie("show_cookie_banner", "0");
      JBCookie.setCookie("cookie_banner_suppressed", "0");
      this.dispatchEvent(new CustomEvent("jb-popup:close-stack", { bubbles: true, composed: true }));
    } else {
      this.dispatchEvent(new CustomEvent("jb-popup:close", { bubbles: true, composed: true }));
    }
  }
  _forceSetting(e, state) {
    const { name } = e.detail.buttonSwitch;
    e.detail.buttonSwitch.setState(state);
    this._newCookieSettings.set(name, state);
  }
  _handleCloseIconClick() {
    this.dispatchEvent(new CustomEvent("jb-popup:close", { bubbles: true, composed: true }));
  }
  _handleKeyBoardEvent(evt) {
    const target = evt.target;
    if (target.tagName === "A") {
      return;
    }
    switch (evt.code) {
      case "Escape":
        this._handleCloseIconClick();
        break;
      case "Space":
        if (target.tagName === "JB-RICHTEXT") {
          evt.preventDefault();
          break;
        }
        break;
      default:
        break;
    }
  }
  _handleKeyboardSelectionOnCloseIcon(evt) {
    if (evt.code === "Enter" || evt.code === "Space") {
      evt.preventDefault();
      this._handleCloseIconClick();
    }
  }
  static _initializeSetting(e) {
    const { name } = e.detail.buttonSwitch;
    const value = JBCookie.getCookie(name);
    if (value) {
      e.detail.buttonSwitch.setState(true);
    }
  }
  _save() {
    this._newCookieSettings.forEach((value, key) => {
      if (value) {
        JBCookie.setCookie(key, "1", void 0, true);
      } else {
        JBCookie.deleteCookie(key);
      }
    });
    document.body.dispatchEvent(
      new CustomEvent("jb-cookie-settings:update", {
        bubbles: true,
        composed: true,
        detail: { updatedCookieSettings: this._newCookieSettings }
      })
    );
    this._newCookieSettings = /* @__PURE__ */ new Map();
  }
  _settingChanged(e) {
    e.stopPropagation();
    this._newCookieSettings.set(e.detail.name, e.detail.checked);
  }
  render() {
    return ke`
      <section @keydown=${this._handleKeyBoardEvent}>
        <div class="container">
          <button
            @click=${this._handleCloseIconClick}
            @keydown=${this._handleKeyboardSelectionOnCloseIcon}
            aria-label="${this.ariaLabels?.closeCookieSettings ?? this.ARIALABELS_DEFAULT.closeCookieSettings}"
          >
            <jb-close-icon></jb-close-icon>
          </button>
          <h2>${this.headline}</h2>
          <slot name="introduction"></slot>
          <div class="options">
            <slot
              name="options"
              @button-switch:initialized=${JbCookieSettings._initializeSetting}
              @button-switch:changed=${this._settingChanged}
            ></slot>
            <div class="additional-text">
              ${this.additionalHeadline ? ke`<h4>${this.additionalHeadline}</h4>` : D}
              <slot name="additionalText"></slot>
            </div>
          </div>
          <jb-button-panel @jb-button:clicked=${this._buttonClicked}>
            <jb-button-secondary
              inverted
              name="cancel"
              aria-label=${this.ariaLabels?.closeCookieSettings ?? this.ARIALABELS_DEFAULT.closeCookieSettings}
            >
              ${this.cancelButtonText}
            </jb-button-secondary>
            <jb-button-primary
              inverted
              name="save"
            >
              ${this.saveButtonText}
            </jb-button-primary>
          </jb-button-panel>
        </div>
      </section>
    `;
  }
};
JbCookieSettings.styles = [reset_css_default, jb_cookie_settings_css_default];
JbCookieSettings.shadowRootOptions = { ...r.shadowRootOptions, delegatesFocus: true };
__decorateClass([
  n()
], JbCookieSettings.prototype, "additionalHeadline", 2);
__decorateClass([
  n({ type: Object })
], JbCookieSettings.prototype, "ariaLabels", 2);
__decorateClass([
  n()
], JbCookieSettings.prototype, "cancelButtonText", 2);
__decorateClass([
  n()
], JbCookieSettings.prototype, "headline", 2);
__decorateClass([
  n()
], JbCookieSettings.prototype, "saveButtonText", 2);
JbCookieSettings = __decorateClass([
  customElement("jb-cookie-settings")
], JbCookieSettings);

export {
  JbCookieSettings
};
